import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, Phone, Instagram } from 'lucide-react';
import { WA_MAIN, getTelLink, trackPhoneClick, toDisplay, INSTAGRAM_URL, INSTAGRAM_HANDLE } from '../mock';

const menuItems = [
  { label: 'Inicio', target: 'inicio' },
  { label: 'Quiénes Somos', target: 'nosotros' },
  { label: 'Nuestro Equipo', target: 'equipo' },
  { label: 'Servicios', target: 'servicios' },
  { label: 'Testimonios', target: 'testimonios' },
  { label: 'Agendar Turno', target: 'turnos' },
  { label: 'Preguntas Frecuentes', target: 'faq' },
  { label: 'Contacto', target: 'contacto' },
];

const Header = ({ phone = WA_MAIN }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleToggle = () => {
    setOpen(prev => !prev);
  };

  const handleNavClick = (target) => {
    setOpen(false);
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: target } });
      return;
    }
    setTimeout(() => {
      const element = document.getElementById(target);
      if (element) {
        const headerHeight = 80;
        const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementTop - headerHeight,
          behavior: 'smooth'
        });
      }
    }, 300);
  };

  // Lock body scroll when menu is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <>
      <header className="site-header">
        <div className="header-phone-bar">
          <a href={getTelLink(phone)} onClick={trackPhoneClick} className="header-bar-link" data-testid="header-phone-mobile">
            <Phone className="w-4 h-4" strokeWidth={2} />
            <span>Llamanos: {toDisplay(phone)}</span>
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="header-bar-link header-bar-instagram"
            aria-label={`Instagram ${INSTAGRAM_HANDLE}`}
            data-testid="header-instagram-mobile"
          >
            <Instagram className="w-5 h-5" strokeWidth={2} />
          </a>
        </div>
        <div className="header-container">
          <div className="header-contact-group">
            <a href={getTelLink(phone)} onClick={trackPhoneClick} className="header-phone-link" data-testid="header-phone-link">
              <Phone className="w-4 h-4" strokeWidth={2} />
              <span>{toDisplay(phone)}</span>
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="header-phone-link header-instagram-link"
              aria-label={`Instagram ${INSTAGRAM_HANDLE}`}
              data-testid="header-instagram-link"
            >
              <Instagram className="w-4 h-4" strokeWidth={2} />
              <span>{INSTAGRAM_HANDLE}</span>
            </a>
          </div>
          <Link to="/" className="header-logo" data-testid="header-logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_legal-humana/artifacts/lct2abwc_sampellegrini_jaliff_logo_v3_institutional-removebg-preview.png" 
              alt="Sampellegrini & Jaliff - Estudio Jurídico"
              className="logo-image"
            />
          </Link>
          <button 
            className="menu-trigger" 
            onClick={handleToggle}
            aria-label={open ? "Cerrar menú" : "Abrir menú"}
            aria-expanded={open}
            data-testid="nav-menu-trigger"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </header>

      {/* Overlay backdrop */}
      <div 
        className={`nav-overlay ${open ? 'nav-overlay-visible' : ''}`}
        onClick={() => setOpen(false)}
        aria-hidden="true"
      ></div>

      {/* Side panel */}
      <aside className={`nav-panel ${open ? 'nav-panel-open' : ''}`} aria-hidden={!open}>
        <div className="nav-menu-header">
          <h3 className="nav-menu-title">Navegación</h3>
        </div>
        <nav className="nav-menu-list">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={() => handleNavClick(item.target)}
              className="nav-menu-item"
              data-testid={`nav-item-${item.target}`}
              tabIndex={open ? 0 : -1}
            >
              {item.label}
            </button>
          ))}
        </nav>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="nav-instagram-link"
          data-testid="nav-instagram-link"
          tabIndex={open ? 0 : -1}
        >
          <Instagram className="w-5 h-5" strokeWidth={1.8} />
          <span>{INSTAGRAM_HANDLE}</span>
        </a>
        <div className="nav-menu-footer">
          <p className="nav-footer-text">
            Sampellegrini & Jaliff
          </p>
          <p className="nav-footer-subtext">
            Abogacía humana, soluciones reales
          </p>
        </div>
      </aside>
    </>
  );
};

export default Header;
